import { FC, useRef, useEffect } from 'react'

const isSupported = 'IntersectionObserver' in window

type VisibilityHandlerProps = {
  options?: IntersectionObserverInit
  className?: string
  disabled?: boolean
  onChange?: (isVisible: boolean | null) => void
}

export const VisibilityHandler: FC<VisibilityHandlerProps> = (props) => {
  const { children, className, onChange, ...restProps } = props

  useEffect(() => {
    if (!isSupported && onChange) {
      onChange(null)
    }
  }, [onChange])

  if (!isSupported) {
    return (
      <div className={ className }>
        { children }
      </div>
    )
  }

  return (
    <VisibilityHandlerInner
      className={ className }
      onChange={ onChange }
      { ...restProps }
    >
      { children }
    </VisibilityHandlerInner>
  )
}

const VisibilityHandlerInner: FC<VisibilityHandlerProps> = (props) => {
  const { children, onChange, options, className, disabled } = props

  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const { current } = rootRef
    if (!onChange || !current || disabled) {
      return
    }

    const handle = (entries: IntersectionObserverEntry[]) => {
      const isVisible = Boolean(entries[0] && entries[0].isIntersecting)
      onChange(isVisible)
    }

    const observer = new IntersectionObserver(handle, options)
    observer.observe(current)
    return () => {
      observer.disconnect()
    }
  }, [onChange, options, disabled])

  return (
    <div ref={ rootRef } className={ className }>
      { children }
    </div>
  )
}
